import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CalendarAPIService {
  constructor(private api: ApiService) {}

  // GET API

  checkGoogleCalendarConnectedStatus() {
    return this.api.get(`/google/authurl?user_id=${this.api.getUserId()}`);
  }
  disconnectGoogleAccount() {
    return this.api.post('/google/disconnect', { user_id: this.api.getUserId() });
  }
  getUserCalendarAccess(userId: string = null) {
    let user_id = userId ? userId : this.api.getUserId();
    return this.api.get(`/users/calendar-access-received/${user_id}`);
  }
  getCalendarEventsByLeadId(leadId: string) {
    return this.api.get(`/google/authurl?leadid=${leadId}&user_id=${this.api.getUserId()}`);
  }
  getCalendarEventsByModuleName(id: string, moduleName: string = 'property_id', exclude_settled: boolean = false) {
    return this.api.get(`/calendar/fetch-property-events?${moduleName + `=${id}`}&exclude_settled=${exclude_settled}`);
  }
  getUserCalendarDetails(calendar_user) {
    return this.api.get('/user-calendar/calendar-list?user_id=' + calendar_user);
  }

  getListingContactEventsById(contact_id: string) {
    return this.api.get(`/calendar/fetch-property-events?office_id=${this.api.getOfficeId()}&exclude_settled=${true}&contact_id=${contact_id}`);
  }
  getProjectContactEventsById(contact_id: string = '', lead_id: string = '', project_id: string = '') {
    return this.api.get(
      `/calendar/fetch-project-events?office_id=${this.api.getOfficeId()}&contact_id=${contact_id}&lead_id=${lead_id}&project_id=${project_id}`
    );
  }

  // POST API

  getUserCalendarEvents(payload: any) {
    return this.api.post('/user-calendar/fetch', payload);
  }
  startCalendarWatch() {
    return this.api.post('/start-calendar-watch', { user_id: this.api.getUserId() });
  }
  insertCalendarEvent(payload: any) {
    return this.api.post('/calendar/insert-new-event', payload);
  }
  stopCalendarWatch() {
    return this.api.post('/stop-calendar-watch', { user_id: this.api.getUserId() });
  }
  getCalendarEventsByUserIds(userId: string | string[], moduleName: string = 'Property') {
    return this.api.post('/multiple-user-calendar/fetch', { user_id: userId, type: moduleName });
  }
  removeCalendarById(payload: any) {
    return this.api.post('/calendar/delete', payload);
  }
  createUserCalendar(calendar_user, payload: any) {
    return this.api.post('/user-calendar/add-new-calendar?user_id=' + calendar_user, payload);
  }
  createMultipleOfiEvent(payload: any) {
    return this.api.post('/calendar/insert-multiple-property-ofi-event', payload);
  }

  // PUT API

  updateUserCalendar(calendar_user, payload: any) {
    return this.api.put('/user-calendar/update-calendar?user_id=' + calendar_user, payload);
  }
  deleteCalendar(calendar_user, calendar_id) {
    return this.api.put('/user-calendar/delete-calendar?user_id=' + calendar_user, { id: calendar_id });
  }
  updateSelectedCalendar(calendar_user, payload: any) {
    return this.api.put('/user-calendar/update-selected-calendar?user_id=' + calendar_user, payload);
  }

  // DELETE API

  removeEventFromCalendarByUserId(userId: string, calendarId: string, eventId: string = '') {
    let payload = {
      user_id: userId,
      calendarId: calendarId,
      eventId: eventId || '',
    };
    return this.api.delete('/calendar/delete-event', payload);
  }
  removeProjectEventFromCalendarByUserId(payload: any) {
    return this.api.post('/calendar/delete-event-projects', payload);
  }
}
